import { eq, flow, get } from 'lodash/fp';
import { filter, tap, map } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { ACTIONS } from 'redux-api-call';
import { updateAdminUserAC } from '../../apiCalls/adminUsers/get';
import { VERIFY_USER_API_ID } from '../../apiCalls/adminUsers/verify';

const handleVerifySuccess = (actions$, store$) =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(
      flow(
        get('payload.name'),
        eq(VERIFY_USER_API_ID)
      )
    ),
    tap(action => {
      console.log(action);
    }),
    map(action => {
      const user = get('payload.json.user')(action);
      return updateAdminUserAC(user, store$.value);
    })
  );

export default combineEpics(handleVerifySuccess);
